import React from "react";

import { Box, Typography } from "@material-ui/core";

import useColourPalette from "components/visuals/useColourPalette";
import KPIComparison from "components/visuals/KPIComparison";

import { useAppSelector } from "store";
import { selectFootfallLevel } from "modules/customer/tools/location/footfall/footfallSlice";
import { selectIsLoading, selectHasErrors } from "modules/customer/tools/location/footfall/footfallSlice";
import { selectComparatorsByChapter } from "modules/customer/tools/location/locationSlice";
import numberFormatter from "utils/numberFormatter";

const FootfallLevel: React.FC = () => {
    const colourPalette = useColourPalette();
    const isLoading = useAppSelector(selectIsLoading);
    const hasErrors = useAppSelector(selectHasErrors);
    const comparator = useAppSelector(selectComparatorsByChapter)?.footfall;
    const footfallLevel = useAppSelector(selectFootfallLevel);
    const comparatorValue = footfallLevel.comparator;
    const selectedLocationValue = footfallLevel.selectedLocation;
    const differenceValue = selectedLocationValue - comparatorValue;

    return (
        <Box width="100%" height="100%" data-cy="footfall-level">
            <KPIComparison
                isLoading={isLoading}
                hasErrors={hasErrors}
                targetValue={
                    <Typography variant="h3" component="div" style={{ color: colourPalette.comparators[0] }}>
                        {numberFormatter.toDecimalPlaces(selectedLocationValue, 1)}
                    </Typography>
                }
                targetLabel="Footfall level in the selected location"
                comparisonValue={
                    <Typography variant="h6" component="div" style={{ color: colourPalette.comparators[1] }}>
                        {numberFormatter.toDecimalPlaces(comparatorValue, 1)}
                    </Typography>
                }
                comparisonLabel={`Comparator: ${comparator?.storeName}`}
                differenceValue={
                    <Typography variant="h6" component="div">
                        {numberFormatter.toDecimalPlaces(differenceValue, 1)}
                    </Typography>
                }
                differenceLabel="Difference"
            />
        </Box>
    );
};

export default FootfallLevel;
